/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { selectPublishedOnly } from '../chat/chatSlice';
import { fetchAutoCompleteThunk } from '../chat/searchSlice';
import { selectPearlUserInfo } from '../Login/userSlice';

export function useCommonAppStartup() {
  const dispatch = useAppDispatch();
  const isLoggedIn = !!useAppSelector(selectPearlUserInfo);
  const publishedOnly = useAppSelector(selectPublishedOnly);
  /** Fetch the autocomplete list early on */
  useEffect(() => {
    if (!isLoggedIn) return;
    const p = dispatch(fetchAutoCompleteThunk({ publishedOnly }));
    return () => p.abort(); // Cleanup when navigating away
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publishedOnly, isLoggedIn]);
}
